// NOTE: this module has been deprecated under the removeAngularJsonFeature flag
angular.module('bb.assets', ['ngRoute']);

require('./assets.routes');

require('./assets.service');

require('./assets_list.component');
require('./folder_modal.component');
require('./video_player_modal.component');
require('./add_video_modal.component');
require('./file_searchbar.component');
